import { Theme } from '@mui/system';

export default ({ palette }: Theme) =>
	`repeating-conic-gradient(${
		palette.grey[palette.mode === 'dark' ? 600 : 100]
	} 0% 25%, ${
		palette.grey[palette.mode === 'dark' ? 800 : 300]
	} 0% 50%) 50% / 32px 32px`;
